<template>
  <GlobalHeader v-if="showHeaderAndFooter" />
  <main id="main-content">
    <slot />
  </main>
  <GlobalFooter v-if="showHeaderAndFooter" />
  <CookieBanner />
</template>

<script setup lang="ts">
const showHeaderAndFooter = useState('showHeaderAndFooter')
const head = useLocaleHead({
  addDirAttribute: true, // Adds dir
  addSeoAttributes: true, // Adds lang,
  seo: true // Adds SEO attributes
})
useHead(() => ({
  htmlAttrs: head.value.htmlAttrs,
  meta: head.value.meta,
  link: head.value.link
}))
</script>

